@if (product$ | async) {
<div>
  @if (isTile) {
  <custom-dot-cms-uve-product-tile [layout]="layout()" />
  }
</div>
} @if (loading$ | async) {
<ish-loading />
}
